import { Component, Input, OnInit } from '@angular/core';
import { AVAILABLE_BANNER_CONFIG, IBannerConfig } from './banner-cofig';

@Component({
    selector: 'app-banner',
    styleUrls: ['./banner.component.scss'],
    templateUrl: './banner.component.html',
    standalone: false
})
export class BannerComponent implements OnInit {

  @Input()
  public type: string;
  public config: IBannerConfig;

  constructor() { }

  public get dismissable(): boolean { return this.config.dismissble; }
  public get icon(): string { return this.config.icon; }
  public get style(): string { return this.config.style; }

  public ngOnInit() {
    this.config = AVAILABLE_BANNER_CONFIG[this.type];
  }
}
